import type { ComponentProps } from "react";
import { Image, Platform, Pressable, StyleSheet, View } from "react-native";

import { Text } from "@/design/Text";
import { fonts, palette, space } from "@/design/tokens";

type PressableProps = Omit<
  ComponentProps<typeof Pressable>,
  "accessibilityLabel" | "accessibilityRole" | "children" | "style"
>;

/**
 * The canonical brand lockup for centered auth and conversion cards.
 *
 * It owns both the icon-to-wordmark gap and the breathing room before the
 * card's message so individual states cannot accidentally stack margins.
 */
export function CenteredCardBrand({
  interactionProps
}: {
  interactionProps?: PressableProps;
}) {
  const content = (
    <>
      <Image
        accessible={false}
        source={require("../../assets/brand-icon.png")}
        style={styles.icon}
      />
      <Text accessible={false} style={styles.wordmark}>
        Recital Master
      </Text>
    </>
  );

  if (interactionProps) {
    return (
      <Pressable
        accessibilityLabel="Recital Master"
        accessibilityRole="image"
        {...interactionProps}
        style={[styles.lockup, styles.interactive]}
      >
        {content}
      </Pressable>
    );
  }

  return (
    <View
      accessible
      accessibilityLabel="Recital Master"
      accessibilityRole="image"
      style={styles.lockup}
    >
      {content}
    </View>
  );
}

const styles = StyleSheet.create({
  icon: {
    height: 52,
    width: 52
  },
  interactive: {
    ...Platform.select({ web: { cursor: "auto" }, default: {} })
  } as never,
  lockup: {
    alignItems: "center",
    alignSelf: "center",
    gap: space.md,
    marginBottom: space.sm
  },
  wordmark: {
    color: palette.textSoft,
    fontFamily: fonts.displaySemi,
    fontSize: 18,
    textAlign: "center"
  }
});
